/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiGenerateAiArticlesContentMutationRequest, ContentAiGenerateAiArticlesContentMutationResponse, ContentAiGenerateAiArticlesContentPathParams, ContentAiGenerateAiArticlesContent401, ContentAiGenerateAiArticlesContent403 } from "../models/ContentAiGenerateAiArticlesContent";

export function getContentAiGenerateAiArticlesContentUrl(id: ContentAiGenerateAiArticlesContentPathParams["id"]) {
  const res = { method: 'PUT', url: `/content-ai/v1/contents/${id}/generate-ai-articles` as const }
  return res
}

/**
 * @summary Generate AI articles from media analysis
 * {@link /content-ai/v1/contents/:id/generate-ai-articles}
 */
export async function contentAiGenerateAiArticlesContent(id: ContentAiGenerateAiArticlesContentPathParams["id"], data: ContentAiGenerateAiArticlesContentMutationRequest, config: Partial<RequestConfig<ContentAiGenerateAiArticlesContentMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ContentAiGenerateAiArticlesContentMutationResponse, ResponseErrorConfig<ContentAiGenerateAiArticlesContent401 | ContentAiGenerateAiArticlesContent403>, ContentAiGenerateAiArticlesContentMutationRequest>({ method : "PUT", url : getContentAiGenerateAiArticlesContentUrl(id).url.toString(), data : requestData, ... requestConfig })
  return res.data
}